<template>
    <v-row class="background-container pa-0 ma-0">
        <vue-headful :title="'Disponible en las tiendas'" description="title" />
        <div class="background-banner position-absolute"></div>
        <v-col cols="10" class="mx-auto d-flex justify-center align-center">
            <v-card
                class="d-flex justify-center flex-column border-radius-4 align-center card-banner text-center py-5 px-3"
            >
                <img
                    src="/img/brand/beelogo_line.svg"
                    alt="logo loader"
                    class="banner-logo mx-auto my-4"
                />

                <span class="font-size-24 brown--text">{{ $t('download_app_message') }}</span>

                <v-row class="action-banner mt-4 d-flex justify-center flex-row">
                    <a class="button-banner" target="_blank" href="https://play.google.com/store/apps/details?id=com.beereaders.students">
                        <img :src="gpStoreSrc" class="btn-img-gp" alt="google play badge" />
                    </a>
                    <a class="button-banner mt-2" target="_blank" href="https://apple.co/3aBwCf3">
                        <img :src="appStoreSrc" class="btn-img" alt="apple store badge" />
                    </a>
                </v-row>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'StoreBanner',
    computed: {
        appStoreSrc() {
            return this.$i18n.locale === 'es'
                ? '/img/apps-store/app-es.svg'
                : '/img/apps-store/app-en.svg'
        },
        gpStoreSrc() {
            return this.$i18n.locale === 'es'
                ? '/img/apps-store/gp-es.png'
                : '/img/apps-store/gp-en.png'
        },
    },
}
</script>

<style>
.background-banner {
    background-image: url('/img/user/banner-2.svg');
    background-repeat: no-repeat;
    background-size: cover;
    height: 50%;
    width: 100%;
    top: 0;
}


.card-banner {
    text-align: center;
    padding: 3vh 5vh;
}
.action-banner {
    margin-top: 2vh;
    width: 100%;
}
.button-banner {
    padding: 0;
}
.btn-img {
    width: 200px;
}

.btn-img-gp {
    width: 220px;
}
</style>
